import { InputAdornment, MenuItem, Select, TextField } from '@mui/material';
import { QuantityUnitTypes } from 'api/types/ReferenceData';
import { QuantityUnitType } from 'api/types/ReferenceDataTS';

export const UnitField: React.FC<{
  label: string;
  onChange: (value: { value: string; unit: string }) => void;
  value: { value: string; unit: string };
  required?: boolean;
  disabled?: boolean;
  isSubmitted?: boolean;
  defaultUnit?: QuantityUnitType;
  disableUnitSelection?: boolean;
}> = props => {
  const defaultUnit = props.defaultUnit ?? QuantityUnitTypes[0].value;
  return (
    <TextField
      label={props.label}
      type="number"
      margin="normal"
      fullWidth
      value={props.value?.value ?? ''}
      placeholder="1"
      error={props.isSubmitted && !props.value.value}
      helperText={
        props.isSubmitted && !props.value.value
          ? 'This field is required'
          : undefined
      }
      required={props.required}
      onChange={e =>
        props.onChange({
          value: e.target.value,
          unit: props.value.unit ? props.value.unit : defaultUnit
        })
      }
      slotProps={{
        input: {
          sx: {
            paddingRight: 1
          },

          endAdornment: props.disableUnitSelection ? (
            <InputAdornment position="end">
              {QuantityUnitTypes.find(item => item.value === defaultUnit)
                ?.label ?? 'units'}
            </InputAdornment>
          ) : props.value?.value ? (
            <InputAdornment position="end">
              <Select
                variant="standard"
                margin="none"
                disableUnderline
                onChange={e =>
                  props.onChange({
                    value: props.value.value,
                    unit: e.target.value
                  })
                }
                value={props.value.unit ?? ''}
                disabled={props.disabled}
              >
                {QuantityUnitTypes.map(item => (
                  <MenuItem id={item.value} key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </InputAdornment>
          ) : (
            ''
          )
        }
      }}
      disabled={props.disabled}
    />
  );
};
